/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PostureTenantModel {
    getFixupPrototypeFunction() { return PostureTenantModel.fixupPrototype; }

    static newInstance(model: Partial<PostureTenantModel>): PostureTenantModel {
        let obj = Object.assign(new PostureTenantModel(), model);
        PostureTenantModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PostureTenantModel>): PostureTenantModel {
        if (!model) return null;
        return PostureTenantModel.newInstance(<PostureTenantModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PostureTenantModel) {
        if (!obj) return;

        models.PostureTenantModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PostureTenantModel): boolean {
        Object.setPrototypeOf(obj, PostureTenantModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_wo_tag === undefined) {
            this.resource_wo_tag = 0;
        }
        if (this.total_resources === undefined) {
            this.total_resources = 0;
        }
        if (this.billable_resources === undefined) {
            this.billable_resources = 0;
        }
        if (this.new_resources === undefined) {
            this.new_resources = 0;
        }
        if (this.increase_percentage === undefined) {
            this.increase_percentage = 0;
        }
        if (this.resource_wo_lock === undefined) {
            this.resource_wo_lock = 0;
        }
        if (this.deleted_resources === undefined) {
            this.deleted_resources = 0;
        }
    }

    /**
     * Name of the tenant
     */
    tenant_name: string;

    /**
     * Name of the tenant
     */
    tenant_id: string;

    /**
     * resource without tag count
     */
    resource_wo_tag: number;

    /**
     * total resources
     */
    total_resources: number;

    /**
     * resource without naming std
     */
    resource_wo_naming_std: string;

    /**
     * billable resources
     */
    billable_resources: number;

    /**
     * new resources
     */
    new_resources: number;

    /**
     * increase percentage
     */
    increase_percentage: number;

    /**
     * resources without lock
     */
    resource_wo_lock: number;

    /**
     * deleted resources
     */
    deleted_resources: number;

}
